import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import classnames from 'classnames';
import bowser from 'yola-bowser';

const { InfoWithPopover, Heading, Paragraph } = designSystem;

const isTouchDevice = bowser.mobile || bowser.tablet;

const OptionSection = ({
  children = null,
  bold = false,
  title,
  popoverProps = null,
  wrap = false,
}) => {
  const [isVisible, setIsVisible] = useState(isTouchDevice);

  const className = classnames('ws-option-section', {
    'ws-option-section--wrap': wrap,
  });

  const handlers = {
    onMouseEnter: () => setIsVisible(true),
    onMouseLeave: () => setIsVisible(false),
  };

  const titleWrapper = bold ? (
    <Heading type="heading-6" singleLine>
      {title}
    </Heading>
  ) : (
    <Paragraph isClipped>{title}</Paragraph>
  );

  return (
    <div className={className} {...(!isTouchDevice && { ...handlers })}>
      <div className="ws-option-section__title">
        {titleWrapper}
        {popoverProps && isVisible && (
          <InfoWithPopover {...popoverProps} {...(isTouchDevice && { mode: 'popover' })} />
        )}
      </div>
      <div className="ws-option-section__content">{children}</div>
    </div>
  );
};

OptionSection.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  wrap: PropTypes.bool,
  bold: PropTypes.bool,
  popoverProps: PropTypes.shape({
    title: PropTypes.node,
    content: PropTypes.node,
    imgSrc: PropTypes.string,
  }),
};

export default OptionSection;
